/**
 * The *Spis k dátumu* control of the dashboard header (PRD-0075 R-D2, R-D4): a day, or none for
 * the file as it is now (emptied here, or *Back to today* on the banner a set day shows). No day
 * after today can be picked.
 */
import { useId } from 'react'
import { useTranslation } from 'react-i18next'
import { Input } from '@/components/ui/input'
import { asOfDay, todayDay } from './as-of-day'

export interface AsOfPickerProps {
  /** `YYYY-MM-DD`, or null for now. */
  day: string | null
  onChange: (day: string | null) => void
}

export function AsOfPicker({ day, onChange }: AsOfPickerProps) {
  const { t } = useTranslation()
  const id = useId()
  return (
    <div className="space-y-0.5">
      <label htmlFor={id} className="block text-xs text-muted-foreground">
        {t('caseAsOf.label')}
      </label>
      <Input
        id={id}
        type="date"
        value={day ?? ''}
        max={todayDay()}
        onChange={event => onChange(asOfDay(event.target.value))}
        className="h-8 w-auto px-2 text-sm"
      />
    </div>
  )
}
